import type { DestinationId } from './types'

export interface DestinationDef {
  id: DestinationId
  name: string
  description: string
  icon: string
  accent: string
}

export const DESTINATIONS: DestinationDef[] = [
  {
    id: 'teli',
    name: 'Teli AI',
    description: 'Launch an AI calling campaign for these leads',
    icon: 'https://cdn.magicpatterns.com/patterns/generated-images/c8d98d3d-1a9b-4f83-8415-368d7d17d336.jpg',
    accent: 'violet',
  },
  {
    id: 'five9',
    name: 'Five9',
    description: 'Push records to a dialer calling list',
    icon: 'https://cdn.magicpatterns.com/patterns/generated-images/acca6161-6804-4a0a-ae25-bd0337cb132f.jpg',
    accent: 'teal',
  },
]
